import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import secureLocalStorage from 'react-secure-storage';
import MetaData from '../Components/Helmet/Helmet';
import SideBar from '../Components/SideBar/SideBar';
import { toast, ToastContainer } from 'react-toastify';
import Header from '../Components/Header/Header';
import { clearInventoryDetails } from '../Actions/ProductionActions';
import './Styles/multiuser_manufacture_scan.css';
import Dropdown from '../Components/Dropdown/Dropdown';
import InputField from '../Components/InputField/InputField';
import axios from 'axios';
import moment from "moment";
import { BASEURI } from '../Middleware/axiosInstance';
import { convertDropdown, convertDropdownObject, getEnvironment } from '../Middleware/CommonFun';
import { io } from "socket.io-client";
import DateSelector from "../Components/DatePicker/DateSelector";

const socket = io("http://localhost:5000");

let uri = secureLocalStorage.getItem("BaseURI");
const environment = getEnvironment(uri);

export default function MultiUserManufactureScan() {

  if(environment == 'staging'){
    var imageURL = 'https://staging-laravel.sevenrocks.in/image?link=';
  } else {
    var imageURL = 'https://laravel-live.sevenrocks.in/image?link=';
  }

  const dispatch = useDispatch();
  const storedUser = secureLocalStorage.getItem("user_UUID_MFG");
  let token;
  try {
    token = storedUser ? JSON.parse(storedUser)?.token : undefined;
  } catch (e) {
    token = undefined;
  }

  // Multi User Settings
  // const [multiUserSettingData, setMultiUserData] = useState({
  //   user_id: "",
  //   com_port_number: "",
  //   scanner_prefix: "",
  //   checker_number: "",
  //   production_line_id: "",
  // });

  // useEffect(() => {
  //   let user = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"));

  //   axios.post(`${BASEURI}`, {
  //     service_name: "manufacture_scan_user_detail",
  //     token: token,
  //     "user_id": user.User.id,
  //     type: 'get'
  //   })
  //   .then((result) => {
  //     if (result.data.status == 1) {
  //       var settings = {
  //         user_id: result.data.data.setting.user_id,
  //         com_port_number: result.data.data.setting.com_port_number,
  //         scanner_prefix: result.data.data.setting.scanner_prefix,
  //         checker_number: result.data.data.setting.checker_number,
  //         production_line_id: result.data.data.setting.production_line_id,
  //       }

  //       setMultiUserData(settings)
  //     }
  //   })
  // }, [])

  const [scans, setScans] = useState([]);
  const [scanData, setScanData] = useState();

  const errorSound1 = new Audio("/sound1.mp3");
  const errorSound2 = new Audio("/sound2.mp3");

  useEffect(() => {
    socket.on("connect", () => {
      console.log("🟢 Connected to WebSocket server");
    });

    socket.on("disconnect", () => {
      console.log("🔴 Disconnected from WebSocket server");
    });

    socket.on("barcode-scan", (payload) => {
      console.log("📡 Received scan:", payload);
      setScans((prev) => [...prev, payload]);

      // console.log(multiUserSettingData)

      const _stored = secureLocalStorage.getItem("user_UUID_MFG");
      let user;
      try {
        user = _stored ? JSON.parse(_stored) : null;
      } catch (e) {
        user = null;
      }

      axios.post(`${BASEURI}`, {
        service_name: "manufacture_scan_user_detail",
        token: token,
        "user_id": user?.User?.id,
        type: 'get'
      })
        .then((result) => {
          console.log('manufacture_scan_user_detail response', result?.data);
          if (result.data.status == 1) {
            const prefix = result?.data?.data?.setting?.scanner_prefix || '';
            const comPort = result?.data?.data?.setting?.com_port_number || '';
            axios.post(`${BASEURI}`, {
              token: token,
              service_name: 'mutli_user_manufacture_scan',
              // "input": prefix + '-' + (payload.data || ''),
              "input": (payload.data || ''),
              // "com_port_number": comPort,
              "com_port_number" : payload?.port,
              "machine_id": payload?.machineId
            })
              .then((result) => {
                console.log('multi_user_manufacture_scan response', result?.data);
                if (result.data.status == 1) {
                  // multiUserScanpageDetails();
                  if (result?.data?.data) setScanData(result.data.data)
                } else {
                  if (result?.data?.failure_type == 1) {
                    toast.error(result.data.msg);
                    errorSound1.currentTime = 0;
                    errorSound1.play();
                  } else if (result?.data?.failure_type == 2) {
                    toast.warning(result.data.msg);
                    errorSound2.currentTime = 0;
                    errorSound2.play();
                  } else {
                    toast.error(result.data.msg);
                  }
                }

              })
              .catch((error) => {

              })
          }
        })
    });

    return () => {
      socket.off("barcode-scan");
      socket.off("connect");
      socket.off("disconnect");
    };
  }, []);

  // User Profile State
  const { user_profile } = useSelector((state) => state.userProfile);

  const [isOpened, setIsOpened] = useState(false);
  const handleSidebar = () => {
    setIsOpened(!isOpened);
  };

  const handleRefreshBeforeLogout = () => {
    dispatch(clearInventoryDetails());
  };

  const [machineIds, setMachineIds] = useState([]);
  const [productionLines, setProductionLines] = useState('');
  const [allUsers, setAllUsers] = useState([]);
  const [currentScreenUsers, setCurrentScreenUsers] = useState([]);
  const [cumulativeData, setCumulativeData] = useState(null);
  const [production_line_id, set_production_line_id] = useState();
  const [production_line_name, set_production_line_name] = useState();
  const [machine_ids, set_machine_ids] = useState();
  const [settings, setSettings] = useState();
  const [filterDate, setFilterDate] = useState();

  const handleDate = (date) => {
    setFilterDate(date ? moment(date).format("YYYY-MM-DD") : "");

    localStorage.setItem('date',date ? moment(date).format("YYYY-MM-DD") : "")
  };

  const handleProductionLines = (val) => {
    set_production_line_id(val?.value);
    localStorage.setItem('production_line_id',val?.value)
    set_production_line_name(val?.label);
  };

  const handleMachineId = (val) => {
    set_machine_ids(val?.label);
  };

  function multiUserScanpageDetails() {

    axios.post(`${BASEURI}`, {
      token: token,
      service_name: 'multi_user_scan_page_detail',
      production_line_id : production_line_id,
      machine_id : machine_ids,
      date : filterDate
    })
      .then((result) => {
        if (result.data.status == 1) {
          var production_lines = convertDropdownObject(result.data.list.production_lines);
          setProductionLines(production_lines);

          var machine_ids = result.data.list.machine_ids.map((item, index) => ({
            label: item,
            value: index
          }));
          setMachineIds(machine_ids);
          setSettings(result.data.data.settings.multi_user_min_scan_units);

          const sortedUsers = result.data.data.all_users.sort(
            (a, b) => b.total_manufacture_scan - a.total_manufacture_scan
          );

          setAllUsers(sortedUsers);

          setCurrentScreenUsers(result.data.data.current_screen_users)

          if (Array.isArray(result.data.data.cumulative_data)) {
            setCumulativeData(null);
          } else {
            setCumulativeData(result.data.data.cumulative_data);
          }
        }
      });
  }

  useEffect(() => {
    multiUserScanpageDetails()
  }, [production_line_id, machine_ids, filterDate, scanData])


  return (
    <>
      <MetaData title={`Manufacture Order`} />
      <SideBar isOpened={isOpened} handleSidebar={handleSidebar} />

      <ToastContainer />
      {/* Header Component starts here */}
      <Header
        handleRefreshBeforeLogout={handleRefreshBeforeLogout}
        profile_image={user_profile && user_profile?.data?.profile_image}
        handleSidebar={handleSidebar}
      />
      {/* Header Component starts here */}

      <div className="gantt-chart-wrapper-container">
        <div className="dashboard">
          <div className="header">
            <h1>MULTI USER MANUFACTURE SCAN</h1>

            <div className="filters">
              <div>
                <DateSelector
                // label="Order Created On"
                value={filterDate}
                onChange={(date) => handleDate(date)}
                />
              </div>

              <div className="half-70-dropdown-grid-row">
                <div className='dropdown-width'>
                  <Dropdown
                    placeholder="Choose Production Line"
                    dropdown={productionLines && productionLines}
                    onData={handleProductionLines}
                    value={production_line_name}
                  />
                </div>
              </div>

              <div className="half-70-dropdown-grid-row">
                <div className='dropdown-width'>
                  <Dropdown
                    placeholder="Choose Machine Id"
                    dropdown={machineIds && machineIds}
                    onData={handleMachineId}
                    value={machine_ids}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="content">
            <div>
              <div className="cards mb-24">
                <div className="card blue">
                  <h2>{Number(cumulativeData?.total_scan) || 0}</h2>
                  <p>Total Checked Units Today</p>
                </div>

                <div className="card yellow">
                  <h2>{Number(cumulativeData?.first_inventory_in_count) || 0}</h2>
                  <p>Total MRP Scanning Today</p>
                </div>

                <div className="card pink">
                  <h2>{Number(cumulativeData?.total_alteration_scan) || 0}</h2>
                  <p>Total Alteration Today</p>
                </div>

                <div className="card purple">
                  <h2>{Number(cumulativeData?.total_manufacture_scan) || 0}</h2>
                  <p>Total Checking Quality Checked Units</p>
                </div>

                {/* <div className="card green">
                  <h2>{Number(cumulativeData?.total_manufacture_scan) || 0}</h2>
                  <p>Total Checking Quality Failed Units</p>
                </div> */}

                {/* <div className="card peach">
                  <h2>{Number(cumulativeData?.total_manufacture_scan) || 0}%</h2>
                  <p>Quality Defect Percentage</p>
                </div> */}

                <div className="card red">
                  <h2>₹{Number(cumulativeData?.total_incentive) || 0}</h2>
                  <p>Total Incentives Made Today</p>
                </div>

                <div className="card green">
                  <h2>₹{Number(cumulativeData?.total_ledger_amount) || 0}</h2>
                  <p>Total Ledger Incentives Made Today</p>
                </div>
              </div>

              {
                currentScreenUsers.length > 0
                  ?
                  <div className="d-grid gap-20 grid-column-2">
                    {
                      currentScreenUsers.map((v, i) => {
                        return (
                            <div key={i} className='manufactur-info-card'>
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <div className='mb-10'>
                                  <img src={imageURL+v.user_profile_img} width={60} height={60} className='rounded-circle' />
                                </div>
                                <div>
                                  <h3 className='fs-20 fw-700 mb-16'>{v.user_name}</h3>
                                  <span className='d-block fs-12 fw-400'>Checker No. and Production Line</span>
                                  <span className='d-block fs-20 fw-700'>{v.checker_number}, {v.production_line}</span>
                                </div>
                              </div>
                              {
                                scanData
                                  ?
                                    scanData.user_id == v.user_id
                                    ?
                                    <div className='text-center'>
                                      <img src={imageURL+scanData.product_img} alt="Img" width="200px" height="240px"/>
                                      <span className='d-block fs-14 fw-700'>{scanData.sku}</span>
                                    </div>
                                    :
                                    ''
                                  :
                                  ''
                              }

                            </div>
                            <div className='border m-16 mx-24'></div>
                            <div className="d-flex align-items-center justify-content-between mb-14">
                              <div>
                                <span className='fs-12 fw-400 mb-6 lh-100 d-block'>Scan Type</span>
                                <span className='fs-20 fw-700 lh-100 d-block'>{v.current_scan_type}</span>
                              </div>
                              {
                                scanData
                                  ?
                                  scanData.user_id == v.user_id
                                    ?
                                    <div>
                                      <span className='fs-12 fw-400 mb-6 lh-100 d-block'>Serial Code</span>
                                      <span className='fs-20 fw-700 lh-100 d-block'>{scanData.code}</span>
                                    </div>
                                    :
                                    ''
                                  :
                                  ''
                              }

                            </div>
                            <div className="d-grid gap-11 grid-column-2">
                              <div className='count-box' style={{ background: '#FFE2B2' }}>
                                <div className='text-center'>
                                  <h3 className='fs-30 fw-700 lh-100 mb-6'>{v.total_scan}</h3>
                                  <p className='fs-12 fw-600 mb-0'>Total Count for Today</p>
                                </div>
                              </div>
                              <div className='count-box' style={{ background: '#B2FFC3' }}>
                                <div className='text-center'>
                                  <h3 className='fs-30 fw-700 lh-100 mb-6'>{v.total_alteration_scan}</h3>
                                  <p className='fs-12 fw-600 mb-0'>Total Alterations</p>
                                </div>
                              </div>
                              <div className='count-box' style={{ background: '#FFB2B2' }}>
                                <div className='text-center'>
                                  <h3 className='fs-30 fw-700 lh-100 mb-6'>{v.total_manufacture_scan}</h3>
                                  <p className='fs-12 fw-600 mb-0'>Total Proceeded for Packing</p>
                                </div>
                              </div>
                              <div className='count-box' style={{ background: '#E2E9FF' }}>
                                <div className='text-center'>
                                  <h3 className='fs-30 fw-700 lh-100 mb-6'>{v.last_hour_production}</h3>
                                  <p className='fs-12 fw-600 mb-0'>Last Hour Production</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                  :
                  ''
              }

            </div>

            {/* <!-- Right Panel --> */}
            {
              allUsers.length > 0
                ?
                <div>
                  <div>
                    <h3 className='fs-24 fw-700 lh-30 label-color1 checker-heading' style={{ paddingRight: '30%', marginBottom: '10px' }}>Over all checkers ranks</h3>
                  </div>
                  {/* <div class="rank-panel"> */}

                  {
                    allUsers.map((v, i) => {
                      return (
                        <div key={i} className="rank-card border mb-16" style={{ backgroundColor: '#F2F4FA' }}>
                          <div className="d-flex align-items-center justify-content-between mb-10">
                            <div className="profile">
                              <img src={imageURL+v.user_profile_img} width={60} height={60} />
                              <div>
                                <strong>{v.user_name}</strong>
                                <span>{v.checker_number}</span>
                              </div>
                            </div>
                            {/* <div className='d-inline-flex flex-direction-column align-items-center justify-content-between px-16 py-12 bg-light-green rounded-7'>
                              bg-light-red
                              <span className='fs-16 fw-700 d-block'>1%</span>
                              <span className='fs-12 fw-600 d-block'>TQDP</span>
                            </div> */}
                          </div>
                          <div className="stats">
                            <div className={v.total_manufacture_scan >= settings ? 'stat green' : 'stat bg-light-red'}>
                              <h4 className='fs-30 fw-700 label-color1'>{v.total_manufacture_scan}</h4>
                              <p className='fs-12 fw-600 mb-0'>Total Checked Units</p>
                            </div>
                            <div className="stat white" style={{ backgroundColor: '#fff' }}>
                              <h4 className='fs-30 fw-700 label-color1'>₹{v.total_incentive}</h4>
                              <p className='fs-12 fw-600 mb-0'>Incentive Amount</p>
                            </div>
                          </div>
                        </div>
                      )
                    })
                  }

                  {/* </div> */}
                </div>
                :
                ''
            }

          </div>
        </div>
      </div>
    </>
  )
}
